import React from "react";
import { useSelector } from "react-redux";

const Loader = () => {
  const { apiMessage: offline, commonMessage } = useSelector(
    (state) => state.offlineReducer
  );
  return (
    <div className="tc-custom-loader">
      <div className="loader"></div>
      <span>{commonMessage || offline}</span>
    </div>
  );
};

export default Loader;
